




























import { Vue, Component, Prop } from 'vue-property-decorator';
import { mdbRow, mdbCol, mdbInput, mdbAlert, mdbIcon } from '@folky-tools/mdbvue';
import { PersonalBizumPaymentConfig } from '@/models/common/personal-bizum-payment-config';
import { requiredIf } from 'vuelidate/lib/validators';

@Component({
    components: { mdbRow, mdbCol, mdbInput, mdbAlert, mdbIcon },
    validations: {
        personalBizumPaymentConfig: {
            phoneNumber: {
                required: requiredIf(model => {
                    return model.allowPersonalBizumPayments;
                }),
                isValid(val) {
                    return val ? /^\d{9}$/.test(val) : true;
                }
            }
        }
    }
})
export default class EditPersonalBizumPaymentConfig extends Vue {
    @Prop(PersonalBizumPaymentConfig) private personalBizumPaymentConfig!: PersonalBizumPaymentConfig;

    private hasErrors(): boolean {
        this.$v.personalBizumPaymentConfig.$touch();
        if (this.$v.personalBizumPaymentConfig.$error) {
            return true;
        }
        return false;
    }
}
